import { EntityAlert } from "../../entity/EntityAlert";

export class DtoAlertsPutRes extends EntityAlert {}
